/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Earningsfreecount2Inputs */

const en_earningsfreecount2 = /** @type {(inputs: Earningsfreecount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ ${i?.count} free`)
};

const de_earningsfreecount2 = /** @type {(inputs: Earningsfreecount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ ${i?.count} kostenlos`)
};

/**
* | output |
* | --- |
* | "+ {count} free" |
*
* @param {Earningsfreecount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsfreecount2 = /** @type {((inputs: Earningsfreecount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsfreecount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsfreecount2(inputs)
	return de_earningsfreecount2(inputs)
});
export { earningsfreecount2 as "earningsFreeCount" }